export default function formatCI(ci) {
  const m = ci.trim().match(/^([A-Z]{2})\s?(\d+)$/i);
  return m ? `${m[1].toUpperCase()} ${m[2]}` : ci;
}
